import React from 'react';
import { Link } from 'react-router-dom';
// nodejs library that concatenates classes
import classNames from 'classnames';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// @material-ui/core components
import {
  Avatar,
  ListItem,
  makeStyles,
  Paper,
  Typography,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Chip,
  List,
} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
// import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import matchSorter from 'match-sorter';
// @material-ui/icons
import Menu from '@material-ui/icons/Menu';
// core components
import styles from 'assets/jss/material-kit-react/components/headerStyle.js';
import { HOME } from 'constants/routes';
import { shallowEqual, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Autocomplete } from '@material-ui/lab';
import CircularProgress from '@material-ui/core/CircularProgress';
// import Axios from 'axios';
import { getAllUsers } from 'api/gamerRequests';

const useStyles = makeStyles(styles);

export default function Header(props) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);

  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const {
    auth: { isAuthenticated, user },
    // gamer: { },
  } = useSelector((state) => {
    return {
      auth: state.auth,
      gamer: state.gamer,
    };
  }, shallowEqual);
  const loading = open && options.length === 0;

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      const response = await getAllUsers();
      // await sleep(1e3); // For demo purposes.
      const { data } = response;
      console.log(response.data);
      if (active) {
        setOptions([...data]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);
  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener('scroll', headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener('scroll', headerColorChange);
      }
    };
  });

  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const filterOptions = (options, { inputValue }) =>
    matchSorter(options, inputValue, {
      keys: [
        'name',
        'email',
        'username',
        (item) =>
          item.posts && item.posts.length > 0
            ? item.posts.map((post) => post.title)
            : null,
        (item) =>
          item.posts && item.posts.length > 0
            ? item.posts
              ? item.posts.map((post) => post.tags.map((tag) => tag))
              : null
            : null,
      ],
    });

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName('header')[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName('header')[0]
        .classList.add(classes[changeColorOnScroll.color]);
    } else {
      document.body
        .getElementsByTagName('header')[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName('header')[0]
        .classList.remove(classes[changeColorOnScroll.color]);
    }
  };
  const { color, rightLinks, leftLinks, brand, fixed, absolute } = props;
  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed,
  });
  const brandComponent = (
    <Link to={HOME}>
      <Button>{brand}</Button>
    </Link>
  );

  return (
    <AppBar className={appBarClasses}>
      <Toolbar className={classes.container}>
        {leftLinks !== undefined ? brandComponent : null}
        <div className={classes.flex}>
          {leftLinks !== undefined ? (
            <Hidden smDown implementation='css'>
              {leftLinks}
            </Hidden>
          ) : (
            brandComponent
          )}
        </div>
        {isAuthenticated && user !== null && (
          <div className={classes.search}>
            <Autocomplete
              autoComplete
              autoHighlight
              loadingText={<span style={{ color: 'white' }}> Loading...</span>}
              ListboxComponent={Paper}
              classes={{
                paper: classes.paper,
                listbox: classes.paper,
                // popper: classes.paper,
              }}
              // ListboxProps={{ backgroundColor: 'black' }}
              id='asynchronous-demo'
              style={{ width: width < 600 ? 200 : 300 }}
              open={open}
              filterOptions={filterOptions}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              getOptionSelected={(option, value) =>
                option.name === value.name ? option.name : null
              }
              renderOption={(option, { selected }) => (
                <List
                  style={{
                    width: '100%',
                    maxWidth: 360,
                  }}
                >
                  <Link to={`/dashboard/profile/${option.username}`}>
                    <ListItem alignItems='flex-start'>
                      <ListItemAvatar>
                        <Avatar alt={option.username} src={option.photo} />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <span style={{ color: 'white' }}>{option.name}</span>
                        }
                        secondary={
                          <React.Fragment>
                            <Typography
                              component='span'
                              variant='body2'
                              className={classes.inline}
                              style={{ color: 'white' }}
                            >
                              {option.username}
                            </Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction
                        style={{ justifyContent: 'flex-end' }}
                      >
                        <Chip
                          variant='outlined'
                          size='small'
                          label={option.myRating}
                          clickable
                          style={{
                            color: option.myRating > 3 ? 'green' : 'red',
                            borderColor: option.myRating > 3 ? 'green' : 'red',
                          }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </Link>
                </List>
              )}
              getOptionLabel={(option) => {
                return option.name;
              }}
              options={options}
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  style={{
                    color: 'white',
                    '&::WebkitInputPlaceholder': { color: 'blue' },
                    padding: '0.5rem',
                    borderBottom: 'none',
                  }}
                  // label='Search...'
                  variant='standard'
                  placeholder='Search...'
                  classes={
                    {
                      // root: classes.inputRoot,
                      // input: classes.inputInput,
                    }
                  }
                  InputProps={{
                    ...params.InputProps,
                    className: classes.input,
                    startAdornment: <SearchIcon style={{ color: 'white' }} />,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color='inherit' size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </div>
          // <Autocomplete
          //   id='asynchronous-demo'
          //   style={{ width: 300 }}
          //   open={open}
          //   onOpen={() => {
          //     setOpen(true);
          //   }}
          //   onClose={() => {
          //     setOpen(false);
          //   }}
          //   getOptionSelected={(option, value) => option.name === value.name}
          //   getOptionLabel={(option) => option.name}
          //   options={options}
          //   loading={loading}
          //   renderInput={(params) => (
          //     <div className={classes.search}>
          //       <div className={classes.searchIcon}>
          //         <SearchIcon />
          //       </div>
          //       <InputBase
          //         {...params}
          //         placeholder='Search…'
          //         classes={{
          //           root: classes.inputRoot,
          //           input: classes.inputInput,
          //         }}
          //         inputProps={{ 'aria-label': 'search' }}
          //         // InputProps={{
          //         //   ...params.InputProps,
          //         endAdornment={
          //           <React.Fragment>
          //             {loading ? (
          //               <CircularProgress color='inherit' size={20} />
          //             ) : null}
          //             {params.InputProps.endAdornment}
          //           </React.Fragment>
          //         }
          //       />
          //     </div>
          //   )}
          // />
        )}

        <Hidden smDown implementation='css'>
          {rightLinks}
        </Hidden>
        <Hidden mdUp>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
      <Hidden mdUp implementation='js'>
        <Drawer
          variant='temporary'
          anchor={'right'}
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaper,
          }}
          onClose={handleDrawerToggle}
        >
          <div className={classes.appResponsive}>
            {leftLinks}
            {rightLinks}
          </div>
        </Drawer>
      </Hidden>
    </AppBar>
  );
}

Header.defaultProp = {
  color: 'white',
};

Header.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    'transparent',
    'white',
    'rose',
    'dark',
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      'primary',
      'info',
      'success',
      'warning',
      'danger',
      'transparent',
      'white',
      'rose',
      'dark',
      'black',
    ]).isRequired,
  }),
};
